
class TpinController {
    /*@ngInject*/
    constructor($stateParams, $state, $scope, orderStore, auth, $interval, utils, $q) {
        "ngInject";
        _.extend(this, {
        	$stateParams: $stateParams,
        	$state: $state,
            $interval: $interval,
            $scope: $scope,
            orderStore: orderStore,
            auth: auth,
            utils: utils,
            $q: $q
        });
        $scope.tpinBtnHide = true;
        $scope.conutdownTexthide = false;

        var decreamentCountdown=function()
        {
            $scope.tpinBtnHide = true;
            $scope.conutdownTexthide = false;

            $scope.countdown -=1;
            if($scope.countdown<1)
            {
                $scope.tpinBtnHide = false;
                $scope.conutdownTexthide = true;


            }
        };
         $scope.startCountDown=function()
        {
            $interval(decreamentCountdown,1000,$scope.countdown)
        };
        $scope.countdown=15;
        $scope.startCountDown();

        
        this.userNumber = this.auth.currentUser().phone_number;

        this.censoredNumber = this.censorNumber(this.userNumber);

        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId)
            .then(
                (order) => {
                    this.order = order;
                    this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
                    this.itemsVolume = _(this.flatOrderItems)
                        .filter((item) => _.isUndefined(item._destroy))
                        .sum('cubic_feet')
                },
                (error) => this.$q.reject(error)
            );
    }

    requestTPin() {
        this.$scope.countdown = 15;
         this.$scope.startCountDown();
        let user = this.auth.currentUser();
        this.$scope.tpinBtnHide = true;
        this.$scope.conutdownTexthide = false;
        this.loader = this.auth.createUser(user)
            .then(
                (user) => {},
                (error) => alert(error.message)
            );
    }
    enterKey(keyEvent, tpin) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.confirmTPin(tpin);
        }
    }
    checkIfValidForm() {
        const form = this.tpinForm;

        // Set form as submitted
        form.$setSubmitted();
        return form.$valid;


    }
    confirmTPin(tpin) {
        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }
        this.orderLoader = this.auth.login(parseInt(tpin, 10), this.userNumber)
            .then(
                (user) => this.next(),
                (error) => {
                    console.log(error.data);
                    alert("Invalid Tpin!");
                }
            );
    }

    next() {
        this.orderLoader = this.orderStore.saveOrder(this.order, true)
            .then(
                (order) => {
                    const specifiedRedirect = this.$stateParams.redirect;
                    if(this.$stateParams.showSavePopup) {
                        this.utils.showAlertPopup('Order Saved!', 'Order Saved', 'Your order has been saved')
                            .then(() => {
                                /**
                                 * If someone wants us to redirect elsewhere than the quotes page
                                 *  after verifying contact details,
                                 *  obey the directive
                                 */
                                if (specifiedRedirect) {
                                    return this.$state.go(specifiedRedirect, {orderId: order.id});
                                }

                                let [moveType, propertyType] = [order.move_type, order.property_type],
                                    quotePage = this.utils.getQuotePageForOrderWith(moveType, propertyType);

                                this.$state.go(quotePage, {orderId: order.id});
                            });
                    }
                    else {
                        /**
                         * If someone wants us to redirect elsewhere than the quotes page
                         *  after verifying contact details,
                         *  obey the directive
                         */
                        if (specifiedRedirect) {
                            return this.$state.go(specifiedRedirect, {orderId: order.id});
                        }

                        let [moveType, propertyType] = [order.move_type, order.property_type],
                            quotePage = this.utils.getQuotePageForOrderWith(moveType, propertyType);

                        this.$state.go(quotePage, {orderId: order.id});
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
    }

    censorNumber(number) {
        return number[0] + number[1] + 'xxxxxxx' + number[number.length - 1];
    }

}


export default TpinController;


// WEBPACK FOOTER //
// ./client/app/components/tpin/tpin.controller.js